import { getLocale } from "../runtime";

const sv_sum = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Summa`
};

const sum = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_sum(inputs)
	return "sum";
};

export { sum as "sum" };